import { App } from 'vue'
import Calendar from './LpCalendar.vue'

Calendar.install = (Vue: App) => {
  Vue.component(Calendar.name, Calendar)
}

export default Calendar
